<template>
  <div v-if="!canSeeSimUsage">No access.</div>
  <PageLoading v-else-if="requestPending"  />
  <div v-else>
    <!--v-card-->

      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :search="search"
        :items="helicopters"
        :items-per-page="10"
        :sort-by.sync="sortBy"
        class="elevation-1 sim-usage-table"
        :footer-props="{
          itemsPerPageOptions: [10, 30, 50, 500]
        }"
      >
        <template v-slot:item.sim.status_color_text="{ item }">
          <div
            class="mx-auto status-rectangle"
            :style="{
              backgroundColor: item.sim.status_color,
            }"
          ></div>
        </template>
        <template v-slot:item.sim.current_data_usage="{ item }">
          {{  formatBytes(item.sim.current_data_usage) }}
        </template>
        <template v-slot:item.sim.max_data_usage="{ item }">
          {{  formatBytes(item.sim.max_data_usage) }}
        </template>
      </v-data-table>

    <!--/v-card-->

    <p class="sim-usage-default" :title="formatDateAndTime(last_update)">Last updated: {{ formatDateAndTime(last_update, false) }}</p>
    <div class="status-legend-1">
      <div>Status Legend:</div>
      <div class="status-legend-2">
        <div class="status-rectangle green-rectangle"></div>
        <div class="status-legend-3">Usage on track</div>
      </div>
      <div class="status-legend-2">
        <div class="status-rectangle orange-rectangle"></div>
        <div class="status-legend-3">Risk of potential overage</div>
      </div>
      <div class="status-legend-2">
        <div class="status-rectangle red-rectangle"></div>
        <div class="status-legend-3">Overlimit - Data usage out of plan</div>
      </div>
    </div>

  </div>

</template>

<script>
import { DateService } from '../utils/dateService';
import PageLoading from "../views/PageLoading";
import { mapGetters } from 'vuex'

const alignment = 'center';


export default {
  components: {
    PageLoading
  },
  data () {
    return {
      search: '',
      headers: [
        { text: 'Status', value: 'sim.status_color_text', filterable: false, align: alignment, sortable: true },
        { text: 'Serial', value: 'serial', align: alignment },
        { text: 'Type', value: 'display_type', align: alignment },
        { text: 'Registration Number', value: 'registration', align: alignment},
        { text: 'Operator', value: 'operator', align: alignment},
        { text: 'ICCID', value: 'sim.iccid', align: alignment },
        { text: 'Data plan', value: 'sim.max_data_usage', filterable: false, align: alignment },
        { text: 'Current usage', value: 'sim.current_data_usage', filterable: false, align: alignment},
        //{ text: 'Projected usage', value: 'sim.projected_data_usage', filterable: false, align: alignment},
        { text: 'Subscription', value: 'sim.subscription_status', align: alignment},
      ],
      helicopters: [],
      last_update: '',
      requestPending: false,
      sortBy: ['display_type', 'serial'],
    }
  },
  computed: {
    ...mapGetters('userStore', ['canSeeSimUsage'])
  },
  mounted() {
    this.fetchSimUsage();
  },
  methods: {
    projectedConsumption(current_cons, last_update) {
      /*
      Returns the projected consumption at the end of the month.

      last_update: the time of the last update (string)
      current_cons: the current consumption (at time last_update)
      n_days_begin: the number of days since the beginning of the month.
      n_days_month_total: the number of days in the month.
      */

      let last_update_time;
      if (last_update) {
        last_update_time = this.$moment(last_update).utc();
      } else {
        return 0;
      }

      const begin_of_month = this.$moment(last_update_time).startOf('month');
      const end_of_month = this.$moment(last_update_time).endOf('month');

      // To simplify we assume that the first day of the month counts as a full day.
      const n_days_begin = last_update_time.diff(begin_of_month, 'days') + 1;
      const n_days_month_total = end_of_month.diff(begin_of_month, 'days');

      const avg_daily_cons = current_cons / n_days_begin;
      const projection = n_days_month_total * avg_daily_cons;

      return projection;
    },
    processResponse(response) {
      const helicopters = response["helicopters"];
      const last_update = response["last_update"];

      for (let helicopter of helicopters) {
          const current_data_usage = helicopter.sim.current_data_usage;
          const max_data_usage = helicopter.sim.max_data_usage;
          const projected_data_usage = this.projectedConsumption(current_data_usage, last_update);

          // added items
          helicopter.sim.projected_data_usage = projected_data_usage;
          if (current_data_usage > max_data_usage) {
            helicopter.sim.status_color = '#FF0000';
            helicopter.sim.status_color_text = "1_over_usage"
          } else if (projected_data_usage > max_data_usage) {
            helicopter.sim.status_color = '#FF8F2E';
            helicopter.sim.status_color_text = "2_projected_overusage"
          } else {
            helicopter.sim.status_color = '#11BF31';
            helicopter.sim.status_color_text = "3_on_track"
          }
        }
    
      this.helicopters = helicopters;
      this.last_update = last_update;
    },
    formatDateAndTime(time, utcOffset) {
      return DateService.formatDateAndTime(this.$moment, time, utcOffset);
    },
    formatBytes(n) {
      if (n >= 10**9) {
        return Number((n / 10**9).toFixed(2)) + " GB";
      } else if (n >= 10**6) {
        return Math.floor(n / 10**6) + " MB";
      } else if (n >= 10**3) {
        return Math.floor(n / 10**3) + " KB";
      } else {
        return n + " B";
      }
    },
    fetchSimUsage() {
      this.requestPending = true;

      this.$requester
      .get(`/sim_usage?only_managed=false`)
      .then(response => {
        this.processResponse(response.data);
        this.requestPending = false;
      })
      .catch((error) => {
        console.error("Error loading sim usage:", error);
        this.requestPending = false;
      });
    }
  }
}

</script>

<style lang="scss" scoped>

// There is something somewhere that set vertical-align to top but I don't know what.
// This overwrittes this setting.
::v-deep .sim-usage-table > .v-data-table__wrapper > table > thead > tr > th,
::v-deep .sim-usage-table > .v-data-table__wrapper > table > tbody > tr > td {
  vertical-align: middle;
}

.status-rectangle {
  width: 30px;
  height: 20px;
}

.green-rectangle {
  background-color: #11BF31;
}

.orange-rectangle {
  background-color: #FF8F2E;
}

.red-rectangle {
  background-color: #FF0000;
}

.status-legend-1 {
  display: flex;
  align-items: center;
  font-size: medium;
  margin-top: 10px;
  margin-bottom: 20px;
  margin-left: 16px;
}

.status-legend-2 {
  display: flex;
  margin-left: 40px;
  align-items: center;
}

.status-legend-3 {
  margin-left: 5px;
  font-size: smaller;
}

.sim-usage-default {
  color: #000000DE;
  margin-left: 16px;
}

</style>
